/**
 * OwnerPhoneDialog — pede o WhatsApp do DONO na 1ª ativação da integração.
 *
 * Por que existe (medido em PRD, 06/10/2026): das 114 contas com WhatsApp ligado, **85 não têm
 * telefone do dono cadastrado** — e são exatamente as mesmas 85 que estão com o aviso ao dono
 * desligado. Não é desinteresse: a opção mora numa seção que ninguém abre depois de ativar, e sem
 * número a API nem deixa ligar. O dono só descobre que podia receber quando alguém conta.
 *
 * 🔑 **Dá para pular.** O botão secundário ativa sem telefone, exatamente como hoje. Tornar o
 *    número obrigatório transformaria um fluxo que funciona num fluxo que trava — quem não quiser
 *    dar o número ficaria sem WhatsApp nenhum, inclusive para o cliente.
 *
 * Mesmo formato da modal de cobrança (`components/billing/DadosDeCobrancaDialog`): View pura, só `props`.
 */
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  TextField, Button, Stack,
} from '@mui/material';

export default function OwnerPhoneDialog({
  open, phone, setPhone, phoneError, submitting, onSkip, onSubmit,
}) {
  return (
    <Dialog open={open} onClose={submitting ? undefined : onSkip} maxWidth="xs" fullWidth>
      <DialogTitle>Quer receber os agendamentos no seu WhatsApp?</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 2, color: 'var(--color-text-secondary, inherit)' }}>
          Informe o seu número e avisamos você a cada novo agendamento, confirmação ou
          cancelamento — além da mensagem que já vai para o cliente.
        </DialogContentText>

        <TextField
          autoFocus
          fullWidth
          label="Seu WhatsApp"
          placeholder="(11) 91234-5678"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !submitting) onSubmit(); }}
          error={!!phoneError}
          helperText={phoneError || 'Com DDD. Você pode mudar ou desligar depois, em Integrações.'}
          disabled={submitting}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        {/* Coluna, e o "pular" embaixo: a ação que queremos é a de cima, mas a saída
            precisa estar visível — saída escondida vira abandono, não conversão. */}
        <Stack spacing={1} sx={{ width: '100%' }}>
          <Button variant="contained" onClick={onSubmit} disabled={submitting} fullWidth>
            Ativar e receber avisos
          </Button>
          <Button onClick={onSkip} disabled={submitting} fullWidth>
            Ativar sem receber
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
